import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SharedModule } from 'primeng/api';
import { TreeModule } from 'primeng/tree';
import { MenuModule } from 'primeng/menu';
import { SliderModule } from 'primeng/slider';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



import {
  ContentToggleComponent,
  FormatNumToTime,
  InDate,
  InputGroupComponent,
  NumToShortWeekdayPipe,
  PropertyValuePipe,
  SafeUrlPipe,
  ShortToFullWeekdayPipe,
  SortByPipe,
  TableColumnsMultiselectComponent,
  AutoCompleteComponent,
  TreeTableComponent,
  ButtonComponent,
  BreadcrumbComponent,
  FileComponent,
  InputTextComponent,
  TextareaComponent,
  PanelComponent,
  ComponentContainerComponent,
  CheckboxComponent,
  DropdownComponent,
  TableComponent,
  EmptyComponent,
  PreloaderComponent,
  InsparkStickyComponent,
  InsparkHeaderComponent,
  ToolbarComponent,
  InsparkTemplate,
  SelectButtonComponent,
  StatusCircleComponent,
  SvgComponent,
  SwitcherComponent,
  InlineMessageComponent,
  LinkComponent,
  TooltipComponent,
  RadiobuttonComponent,
  SelectListComponent,
  ObjectTreeComponent,
  ModalInputTextComponent,
  InsparkMessageService, InsparkDialogService,
} from '@inspark/inspark-components';

const COMPONENTS = [
  AutoCompleteComponent,
  TreeTableComponent,
  ButtonComponent,
  InputTextComponent,
  TextareaComponent,
  PanelComponent,
  ComponentContainerComponent,
  CheckboxComponent,
  DropdownComponent,
  TableComponent,
  EmptyComponent,
  PreloaderComponent,
  InsparkStickyComponent,
  InsparkHeaderComponent,
  ToolbarComponent,
  BreadcrumbComponent,
  FileComponent,
  InsparkTemplate,
  SelectButtonComponent,
  StatusCircleComponent,
  SvgComponent,
  SwitcherComponent,
  InlineMessageComponent,
  LinkComponent,
  TooltipComponent,
  RadiobuttonComponent,
  SelectListComponent,
  ObjectTreeComponent,
  ModalInputTextComponent,
  ContentToggleComponent,
  InputGroupComponent,
  TableColumnsMultiselectComponent,
];

const PIPES = [
  PropertyValuePipe,
  SafeUrlPipe,
  SortByPipe,
  ShortToFullWeekdayPipe,
  NumToShortWeekdayPipe,
  FormatNumToTime,
  InDate
];

const MODULES = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  BreadcrumbModule,
  RadioButtonModule,
  SharedModule,
  TreeModule,
  MenuModule,
  SliderModule,
  InlineSVGModule,
  NgbModule,
];

@NgModule({
  imports: [...MODULES, ...PIPES, ...COMPONENTS],
  declarations: [],
  exports: [...COMPONENTS, ...PIPES, ...MODULES],
  providers: [InsparkMessageService, InsparkDialogService]
})
export class InsparkUIModule {}
